import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

/**
 * Merkezi rol-tabanlı route guard.
 * - Auth çözülene kadar loader gösterir (protected UI erken render edilmez).
 * - Kullanıcı yoksa → /giris (returnTo query param'ıyla).
 * - Rol yetkisiz → /403 (Forbidden sayfası).
 *
 * Kullanım:
 *   <RoleGuard allow={["teacher","school_admin"]}><Page/></RoleGuard>
 */
export default function RoleGuard({ allow = [], children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();

  if (loading) {
    return (
      <div
        role="status"
        aria-live="polite"
        aria-label="Yetki kontrol ediliyor"
        className="min-h-[40vh] grid place-items-center"
      >
        <Loader2 className="animate-spin text-muted-foreground" size={22} />
      </div>
    );
  }
  if (!user) {
    const returnTo = encodeURIComponent(loc.pathname + loc.search);
    return <Navigate to={`/giris?returnTo=${returnTo}`} replace />;
  }
  if (allow.length === 0) return children;
  if (!allow.includes(user.role)) return <Navigate to="/403" replace />;
  return children;
}
